const commonAssets = {
  homeBg: '/static/images/TOP_background@2x.png',
  blankImage: '/static/images/noData.png',
  scanIcon: '/static/images/scanCode.png',
  bagCodeRecordIcon: '/static/images/bag-code-record.png',
  memberRecordIcon: '/static/images/member-record.png',
  nonMemberRecordIcon: '/static/images/non-member-record.png'
}

const configs = {
  yizhuanjia: {
    key: 'yizhuanjia',
    brandId: 1,
    appId: 'wx1b71958fecb624cb',
    name: '衣专佳',
    loginTitle: '衣专佳',
    theme: 'yizhuanjia',
    home: 'yizhuanjia',
    enableRegionManager: false,
    assets: {
      ...commonAssets,
      logo: '/static/brand/yizhuanjia/logo.png',
      homeBg: '/static/brand/yizhuanjia/TOP_background@2x.png',
      scanIcon: '/static/brand/yizhuanjia/scanCode.png',
      blankImage: '/static/images/wudingdan.png',
      blankImageStyle: {
        width: '180px',
        height: 'auto'
      },
      icons: {
        createWashOrder: '/static/brand/yizhuanjia/icons/record_order.png',
        waybillWashOrder: '/static/brand/yizhuanjia/icons/worked.png',
        expressOrder: '/static/brand/yizhuanjia/icons/express.png',
        pickupOrder: '/static/brand/yizhuanjia/icons/pickup.png',
        queryExpress: '/static/brand/yizhuanjia/icons/send_back.png',
        searchOrder: '/static/brand/yizhuanjia/icons/searchOrder.png',
        createCollectWashOrder: '/static/brand/yizhuanjia/icons/yiwuhexiao.png',
        waitCollect: '/static/brand/yizhuanjia/icons/cikadaishou.png',
        douYinVerify: '/static/brand/yizhuanjia/icons/douyin.png',
        upClothe: '/static/brand/yizhuanjia/icons/yiwushangjia.png',
        pickClothe: '/static/brand/yizhuanjia/icons/gukeziqu.png'
      }
    }
  },
  yishe: {
    key: 'yishe',
    brandId: 1,
    appId: 'wx09b396844095c9af',
    name: '衣奢洗衣',
    loginTitle: '衣奢洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    apiBaseURL: 'https://yishe.uunbiot.com/',
    assets: {
      ...commonAssets,
      logo: '/static/brand/yishe/logo.png'
    }
  },
  zhuanyixiyi: {
    key: 'zhuanyixiyi',
    brandId: 1,
    appId: 'wx95a4fa534d88a990',
    name: 'FOCUSED专衣洗衣',
    loginTitle: 'FOCUSED专衣洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    apiBaseURL: 'https://zhuanyi.uunbiot.com/',
    assets: {
      ...commonAssets,
      logo: '/static/brand/zhuanyixiyi/logo.png'
    }
  },
  shenhaixian: {
    key: 'shenhaixian',
    brandId: 1,
    appId: 'wx284104218995e677',
    name: '深海线',
    loginTitle: '深海线',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    apiBaseURL: 'https://shenhaixian.uunbiot.com/',
    assets: {
      ...commonAssets,
      logo: '/static/brand/shenhaixian/logo.png'
    }
  },
  xingxi: {
    key: 'xingxi',
    brandId: 2,
    appId: 'wx109fd072a29dad94',
    name: '幸洗洗护',
    loginTitle: '幸洗洗护',
    loginButtonClass: 'cm-bg-yellow1',
    theme: 'xingxi',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/xingxi/logo.png',
      homeBg: '/static/brand/xingxi/TOP_background@2x.png'
    }
  },
  xiaoxiongweini: {
    key: 'xiaoxiongweini',
    brandId: 2,
    appId: 'wxb7bcfb457bd12f71',
    name: '小熊维妮洗衣',
    loginTitle: '小熊维妮洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    apiBaseURL: 'https://zhuanyi.uunbiot.com/',
    assets: {
      ...commonAssets,
      logo: '/static/brand/xiaoxiongweini/logo.png'
    }
  },
  youjing: {
    key: 'youjing',
    brandId: 3,
    appId: 'wx46e375a0ea481002',
    name: '优净家清',
    loginTitle: '优净家清',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/youjing/logo.png'
    }
  },
  yixiangzhixi: {
    key: 'yixiangzhixi',
    brandId: 4,
    appId: 'wx2dab0efdd64d3bfb',
    name: '易享智洗云值守',
    loginTitle: '易享智洗云值守',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/yixiangzhixi/logo.png'
    }
  },
  jiedixing: {
    key: 'jiedixing',
    brandId: 5,
    appId: 'wxeb21af47e2076eea',
    name: '洁涤星',
    loginTitle: '洁涤星',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/jiedixing/logo.png'
    }
  },
  uccxihu: {
    key: 'uccxihu',
    brandId: 6,
    appId: 'wx0587fdaedfc916db',
    name: '优CC洗护',
    loginTitle: '优CC洗护',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/uccxihu/logo.png'
    }
  },
  xiyuebiaoju: {
    key: 'xiyuebiaoju',
    brandId: 7,
    appId: 'wxd77baed2f979105d',
    name: '洗悦镖局',
    loginTitle: '洗悦镖局',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/xiyuebiaoju/logo.png'
    }
  },
  laijinao: {
    key: 'laijinao',
    brandId: 8,
    appId: 'wx2f41ce560693cda8',
    name: '莱金澳洗衣',
    loginTitle: '莱金澳洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/laijinao/logo.png'
    }
  },
  laixiguanjia: {
    key: 'laixiguanjia',
    brandId: 9,
    appId: 'wx67e0c4d5ce9f4a41',
    name: '来喜管家',
    loginTitle: '来喜管家',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/laixiguanjia/logo.png'
    }
  },
  yisiman: {
    key: 'yisiman',
    brandId: 10,
    appId: 'wx69580b25bf5b9b09',
    name: '伊斯曼洗衣',
    loginTitle: '伊斯曼洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/yisiman/logo.png'
    }
  },
  xiduoduo: {
    key: 'xiduoduo',
    brandId: 11,
    appId: 'wxaffe22a6adb7ffb0',
    name: '洗多多洗衣洗鞋',
    loginTitle: '洗多多洗衣洗鞋',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/xiduoduo/logo.png'
    }
  },
  xidouxiyi: {
    key: 'xidouxiyi',
    brandId: 13,
    appId: 'wx3239865a8d72522b',
    name: '锡都洗衣',
    loginTitle: '锡都洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/xidouxiyi/logo.png'
    }
  },
  naiyijie: {
    key: 'naiyijie',
    brandId: 14,
    appId: 'wx023206666b355e99',
    name: '耐伊洁',
    loginTitle: '耐伊洁',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/naiyijie/logo.png'
    }
  },
  geruite: {
    key: 'geruite',
    brandId: 15,
    appId: 'wx9b91611856765ef8',
    name: '歌瑞特洗衣',
    loginTitle: '歌瑞特洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/geruite/logo.png'
    }
  },
  haileshenghuo: {
    key: 'haileshenghuo',
    brandId: 16,
    appId: 'wx2490e1453152e621',
    name: '校园洗衣洗鞋店',
    loginTitle: '校园洗衣洗鞋店',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/haileshenghuo/logo.png'
    }
  },
  hetangxiyi: {
    key: 'hetangxiyi',
    brandId: 17,
    appId: 'wxb66917752fd78311',
    name: '禾唐洗衣',
    loginTitle: '禾唐洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/hetangxiyi/logo.png'
    }
  },
  langjiexiyi: {
    key: 'langjiexiyi',
    brandId: 18,
    appId: 'wxa30c048e2f8e6bf4',
    name: '朗洁洗衣',
    loginTitle: '朗洁洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/langjiexiyi/logo.png'
    }
  },
  changexiyi: {
    key: 'changexiyi',
    brandId: 19,
    appId: 'wxca901aff7a486414',
    name: '嫦娥洗衣洗鞋',
    loginTitle: '嫦娥洗衣洗鞋',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/changexiyi/logo.png'
    }
  },
  wuyuanxixie: {
    key: 'wuyuanxixie',
    brandId: 20,
    appId: 'wx98ddf907f7f9ee9b',
    name: '5元洗鞋洗衣',
    loginTitle: '5元洗鞋洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: {
      ...commonAssets,
      logo: '/static/brand/wuyuanxixie/logo.png'
    }
  }
}

export default configs



// WEBPACK FOOTER //
// ./src/customer/configs.js